import {useState, useEffect} from 'react';
import { downloadStatement } from 'services/DownloadStatement'
import { decodeStorage } from 'functions/storageBase64';
import { useHistory } from 'react-router-dom'
import swal from 'sweetalert';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import { dataLayerButtons } from 'functions/dataLayerFunction'


export function useEstadoCuenta(){

    const history = useHistory()
    const [period, setPeriod] = useState()
    const [cardending, setCardending] = useState(decodeStorage('cardending'))
    const [response, setResponse] = useState()
    const [ loading, setLoading ] = useState(false)
    
    const [showInfoModal, setShowInfoModal] = useState(false)
    const [infoModalMessage, setInfoModalMessage] = useState('')

     useEffect(()=>{
        if(cardending){
            if(period){
                setLoading(true)
                downloadStatement({cardending, period})
                .then(setResponse)
            }
        }else{
            setCardending(decodeStorage('cardending'))
            history.push(`${BASE_PATH}${SUB_DIRECTORY}consultar-saldo`)
        }
    },[period, cardending])

    const [errorCode, setErrorCode] = useState()
    useEffect(()=>{
        if(response?.statusCode === 200){
            setLoading(false)
            if(response?.data?.returnCode === "06"){
                setInfoModalMessage(response?.data?.returnText || 'Información')
                setShowInfoModal(true)
            }else{
                if(response?.data?.contenido){
                    const linkSource = `data:application/pdf;base64,${response?.data.contenido}`
                    const downloadLink = document.createElement("a");
                    const fileName = `${response?.data?.nombreDocumento}.pdf`
                    downloadLink.href = linkSource
                    downloadLink.download = fileName
                    downloadLink.click()
                    dataLayerButtons({eventName: "descargar_estadocuenta"})
                }
                swal({
                    type: 'info',
                    text: "Se descargo un elemento.",
                    timer: "3000",
                    showConfirm: false
                })
            }
        }
        else if(response?.statusCode === 400){
            let codeError = JSON.parse(response?.data)
            setLoading(false)
            setErrorCode(codeError)
        }else if(response?.statusCode >= 500){
            setLoading(false)
            setErrorCode(response?.statusCode)
        }
    },[response])

    const handleCloseInfoModal = () => setShowInfoModal(false)

    return {
       loading, 
       setPeriod, 
       errorCode,
       showInfoModal,
       infoModalMessage,
       handleCloseInfoModal
    }
}
